import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="667px"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          center
        >
          <CFView textCenter w="100%">
            <CFView mt="22px">
              <CFImage
                w="85%"
                src={heroText}
                alt="Sushi Jo Bar hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mv="30px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="700px"
          m="0 auto"
          maxWidth="1400px"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          center
        >
          <CFView column center>
            <CFImage
              w="500px"
              src={heroText}
              alt="Sushi Jo Bar hero text"
              zIndex={98}
            />
            <CFView mv="40px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
